// third-party
import { combineReducers } from 'redux';

// project imports
import snackbarReducer from './slices/snackbar';
import userReducer from './slices/user';
import menuReducer from './slices/menu';
import processReducer from './slices/process';
import stateMachineReducer from './slices/stateMachines';
import loggerReducer from './slices/logger';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    user: userReducer,
    menu: menuReducer,
    process: processReducer,
    stateMachines: stateMachineReducer,
    logger: loggerReducer
});

export default reducer;
